import { isObject } from 'lodash';

export const getValueForSelect = (
  value,
  returnCode,
  options: Array<{ code: string; name: string }>,
  viewMode: boolean = false,
) => {
  const isObjectValue = isObject(value);

  if (viewMode && isObjectValue) {
    return returnCode ? value?.code : value?.name;
  }

  if (returnCode) {
    return isObjectValue ? value?.code : value;
  }

  const optionName = isObjectValue ? value?.name : value;
  return options.find(({ name }) => name === optionName)?.code;
};
